import React, {
  FC, useEffect, useRef,
} from 'react';
import TempFieldUtils from '../../../../../../../lib/TempFieldUtils';

const LeftToRight: FC<Props> = ({
  children,
  flowId,
  speed,
}) => {
  const divRef = useRef<any>();

  useEffect(() => {
    if (divRef.current && flowId && !TempFieldUtils.aiFlowIds.includes(flowId)) {
      const offsetWidth = divRef.current.offsetWidth;
      let marginLeft = -offsetWidth;
      divRef.current.style.marginLeft = marginLeft;
      const interval = setInterval(() => {
        marginLeft += speed || 8;
        if (marginLeft > offsetWidth) {
          marginLeft = offsetWidth;
        }
        divRef.current.style.marginLeft = `${marginLeft}px`;
        if (marginLeft >= 0) {
          clearInterval(interval);
        }
      }, 10);

      // 组件卸载时清除定时器
      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    if (divRef.current) {
      let opacity = 0;
      const interval = setInterval(() => {
        opacity += 0.05;
        if (opacity > 1) {
          opacity = 1;
        }
        divRef.current.style.opacity = `${opacity}`;
        if (opacity >= 1) {
          clearInterval(interval);
        }
      }, 10);

      // 组件卸载时清除定时器
      return () => clearInterval(interval);
    }
  }, []);


  return (
    <div ref={divRef} style={{ opacity: 0 }}>
      {children}
    </div>
  );
};

export interface Props {
  children: any;
  // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
  flowId?: string;
  speed?: number;
}

export default LeftToRight;
